import { AccessDenied, Check, Poll as PollIcon } from '@tunasong/icons'
import { isManyOfManyPoll } from '@tunasong/schemas'
import type { ManyOfManyPollResponse } from '@tunasong/schemas'
import { EntityLinkById, Typography } from '@tunasong/ui-lib'
import type { FC } from 'react'
import invariant from 'tiny-invariant'
import type { PollProps } from '../poll.js'
import { graphHooks } from '@tunasong/graph-lib/react'
import styles from './view.module.css'

export const ManyOfManyPollView: FC<PollProps> = props => {
  const { poll, userId } = props

  invariant(isManyOfManyPoll(poll), `Poll must be a ManyOfManyPoll`)

  const { entities: allResponses = [], isSuccess: hasLoadedChildren } =
    graphHooks.useEntityChildren<ManyOfManyPollResponse>({
      parentId: poll.id,
      filter: 'pollresponse',
    })
  const userResponse = allResponses.filter(response => response.userId === userId)[0]?.choices

  invariant(isManyOfManyPoll(poll), 'Poll must be many of many')

  const { name = 'Untitled' } = poll

  return (
    <div className={styles.container}>
      <Typography variant="subtitle1">
        <PollIcon /> {name}
      </Typography>
      {poll.closed && (
        <Typography variant="caption" color="secondary">
          The Poll is closed.
        </Typography>
      )}

      {hasLoadedChildren &&
        poll.pollOptions.map((option, idx) => (
          <div className={styles.optionRow}>
            {userResponse?.[idx] ? <Check color="var(--tuna-palette-success-main)" /> : <AccessDenied color="var(--tuna-palette-action-disabled)" />}
            {option.entityRef ? (
              <EntityLinkById entityId={option.entityRef} />
            ) : (
              <Typography variant="subtitle1">{option.name}</Typography>
            )}
          </div>
        ))}
    </div>
  )
}
